export default __webpack_public_path__ + "static/media/entertainment.b65c2064.webp";